"use client";

import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  title: "Estimate & Assessment",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/image_hty3swh1.webp",
  points: ["Comprehensive site evaluation of exterior systems.", "Thermal imaging to detect moisture and insulation gaps.", "Detailed breakdown of material and labor logistics."]
}, {
  title: "Planning",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/image_gd4jttyj.webp",
  points: ["Selection of premium, energy-efficient siding and roofing.", "Visual inspection to detect any weather damage.", "Rigorous project scheduling and permit coordination."]
}, {
  title: "Masterful Execution",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/image_osh2lc0m.webp",
  points: ["Deployment of specialized, certified trade craftsmen.", "Daily site management and quality control protocols.", "Minimal disruption with organized debris management."]
}, {
  title: "Quality Assurance",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1640875/img/image_ekh1f5sw.webp",
  points: ["Multi-point final inspection and client walkthrough.", "Documentation of warranties and maintenance guidelines.", "Complete property restoration and post-build cleanup."]
}];
export default function IlProcessoDiScelta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224670" id="precision-in-practice" className="relative py-24 bg-background text-foreground overflow-hidden" ref={ref}>
      {}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[100px] -z-10 pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-primary/10 rounded-full blur-[80px] -z-10 pointer-events-none" />

      <div className={`max-w-6xl mx-auto px-4 md:px-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
        
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-5xl font-default font-bold text-foreground mb-6 tracking-tighter">
            Precision in Practice
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-sans leading-relaxed">
            A systematic approach to residential restoration, ensuring every siding, roofing, and deck project meets our rigorous standards of architectural excellence.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          {}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-border to-transparent md:-translate-x-1/2" />

          <div className="space-y-16 md:space-y-24">
            {steps.map((step, i) => <div data-index={i} key={i} className={`relative flex flex-col items-center gap-12 md:gap-0 ${i % 2 === 0 ? 'md:flex-row-reverse' : 'md:flex-row'}`}>
                
                {}
                <div className="absolute left-8 md:left-1/2 -translate-x-1/2 flex items-center justify-center bg-background py-6 z-20">
                  <span className="text-6xl md:text-7xl font-default font-bold text-transparent [-webkit-text-stroke:2px_var(--color-primary)] opacity-90 select-none tracking-tighter">
                    0{i + 1}
                  </span>
                </div>

                {}
                <div className={`w-full md:w-1/2 pl-24 md:pl-0 ${i % 2 === 0 ? 'md:pl-20' : 'md:pr-20'}`}>
                  <div className="rounded-md overflow-hidden shadow-md group/img border border-border/50">
                    <img src={step.image} alt={step.title} className="w-full h-64 md:h-80 object-cover transition-transform duration-700 group-hover/img:scale-105" />
                  </div>
                </div>

                {}
                <div className={`w-full md:w-1/2 pl-24 md:pl-0 ${i % 2 === 0 ? 'md:pr-20' : 'md:pl-20'}`}>
                  <Card className="bg-card/80 backdrop-blur-md border-border rounded-md shadow-md hover:shadow-lg transition-all duration-500 relative overflow-hidden group">
                    {}
                    <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                    
                    <CardContent className="p-6 md:p-8 relative z-10">
                      <h3 className="text-2xl font-default font-bold text-foreground mb-6 tracking-tight">
                        {step.title}
                      </h3>
                      <ul className="space-y-4">
                        {step.points.map((point, j) => <li data-index={j} key={j} className="flex items-start gap-3">
                            <div className="mt-1 bg-primary/10 rounded-sm p-1 shrink-0">
                              <Check className="w-4 h-4 text-primary" />
                            </div>
                            <span className="text-muted-foreground font-sans leading-relaxed">
                              {point}
                            </span>
                          </li>)}
                      </ul>
                    </CardContent>
                  </Card>
                </div>

              </div>)}
          </div>
        </div>

        <div className="mt-24 flex justify-center">
          <Button size="lg" className="rounded-md px-8 shadow-md hover:shadow-lg transition-all font-default font-semibold" asChild>
            
          </Button>
        </div>

      </div>
    </section>;
}